import {Component, Input, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Charge} from './charge.model';
import {ChargeService} from './charge.service';
import {RoutePrefix} from '../shared/route-prefix';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-charge-datatable',
  templateUrl: './charge-datatable.component.html'
})
export class ChargeDatatableComponent extends DatatableViewComponent<Charge> implements OnInit, OnDestroy {
  public assignmentType: string;

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @ViewChildren(DatatableComponent) public datatables;

  @Input() routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public displayActions: boolean = true;

  constructor(
    protected router: UIRouter,
    private chargeService: ChargeService
  ) {
    super(chargeService);
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const matches = this.router.stateService.$current.name.match(/^\w+\.(\w+).*$/);
      this.assignmentType = matches[1] || '';

      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.chargeService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public ngOnDestroy(): void {
    this.chargeService.clearRoutePrefix();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.chargeService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('assignment.' + this.assignmentType + '.edit.charge.edit', { chargeId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/charge/charge-datatable.component.ts